module.exports = __webpack_public_path__ + "static/media/thanks.4c14a301.png";